import { DimensionValue, View } from 'react-native';
import { style } from './ProgressBarBackground.styles';
import { LinearGradient } from 'expo-linear-gradient';
import { ProgressBarBackgroundProps } from './ProgressBarBackground.types';
import { useProgressBarBackgroundLogic } from './ProgressBarBackground.logic';

export const ProgressBarBackground = (props: ProgressBarBackgroundProps) => {
  const { progress, children, isCompleted, completedColor } = props;

  const { locations, colors } = useProgressBarBackgroundLogic(props);

  const progressStyles = isCompleted
    ? [style.completed, { backgroundColor: completedColor }]
    : [
        style.progress,
        {
          width: `${progress}%` as DimensionValue,
        },
      ];

  let renderer = children;
  if (!isCompleted) {
    renderer = (
      <LinearGradient
        locations={locations}
        colors={colors}
        start={{ x: 0, y: 0 }}
        end={{ x: 1, y: 0 }}
        style={[style.progress, { width: '100%' }]}
      >
        {renderer}
      </LinearGradient>
    );
  }

  return <View style={progressStyles}>{renderer}</View>;
};
